<div class="sign-up-area ptb-100">
  <div class="container">
    <div class="section-title">
      <h2>Create New Password</h2>
    </div>

    <div class="sign-up-form">
      <form>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="code"
            placeholder="Enter Code"
            #code
          />
        </div>

        <div class="form-group">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Enter New Password"
            #password
          />
        </div>

        <div class="text-center">
          <ng-container *ngIf="loading; else submitButton">
            <button type="button" class="btn default-btn-one">
              <mat-spinner [diameter]="24"></mat-spinner>
            </button>
          </ng-container>
          <ng-template #submitButton>
            <button
              type="button"
              class="btn default-btn-one"
              (click)="onSubmit(code, password)"
            >
              Submit
            </button>
          </ng-template>
        </div>
      </form>
    </div>
  </div>
</div>
